module.exports = __webpack_public_path__ + "static/media/keanu.8bedb0f5.jpg";